export function downloadURL(url: string, filename: string) {
  const link = document.createElement("a");
  link.hidden = true;
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
